import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React, { useState, useEffect, useRef, useCallback } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import CircularProgress from "@mui/material/CircularProgress";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { TextField } from "@mui/material";
import { Tooltip } from "@mui/material";
import { GetControllers } from "./api/documentType";
import { FieldsByTemplate } from "./api/documentType";
import {
  UpdateDocumentOutput,
  UpdateDocumentRestore,
  GetImageDetail,
  GetDocumentDetailInURL,
} from "./api/document";
import { Snackbar } from "@mui/material";
import "./document.css";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Breadcrumbs from "@mui/material/Breadcrumbs";
//import Link from "@mui/material/Link";

import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useParams,
  useLocation,
  useNavigate,
} from "react-router-dom";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

import RenderHighlightAreas from "./screens/document/views/RenderHighlightAreas";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import JsonView from "./screens/document/views/jsonView";
import ExportBar from "./screens/document/helpers/exportBar";
import getBaseApiUrl from "./api/helpers/BaseAPIURL";
import axiosApiInstance from "./api/axiosApiInstance";

//import { TIFFViewer } from "react-tiff";
//import "react-tiff/dist/index.css";

const apiURL = getBaseApiUrl(window.location.hostname);

function Document() {
  const documentID = useParams();
  //const documentID.id = 12795;
  const state = useLocation();

  let navigate = useNavigate();
  let validateForm = 0;
  const [extractedDocument, setExtractedDocument] = useState(undefined);
  const [documentDetails, setDocumentDetails] = useState([]);
  const [documentImage, setDocumentImage] = useState("");
  const [currentIndex, setCurrentIndex] = useState("");
  const [prevDocument, setPrevDocument] = useState([]);
  const [nextDocument, setNextDocument] = useState([]);
  const [documents, setDocuments] = useState(state.state?.documents || []);
  const [displayUI, setDisplayUI] = useState("none");
  const [loading, setLoading] = useState("flex");
  const [templateName, setTemplateName] = useState("");
  const [disableEditButton, setDisableEditButton] = useState(true);
  const [disableEditContent, setDisableEditContent] = useState(false);
  const [InputClass, setInputClass] = useState("xrx-input");
  const [dataForm, setDataForm] = useState("");
  const [invoiceAmount, setInvoiceAmount] = useState("");
  const [formData, setFormData] = useState([]);
  const [prevOutput, setPrevOutput] = useState("");
  const [summaryFieldDocuments, setSummaryFieldDocuments] = useState([]);
  const [controllers, setControllers] = useState([]);
  const [openSnack, setOpenSnack] = useState(false);
  const [errorMessage, setErrorMessage] = useState(
    "Some Error Occured..Please check back later"
  );
  const [checkboxgroup, setCheckboxGroup] = useState("");
  const [selectedValues, setSelectedValues] = useState([]);
  const [model, setModel] = useState("");
  const [review, setReview] = useState(false);
  const [checked, setChecked] = useState(false);
  const [date, setDate] = useState("");
  const [dateFormat, setdateFormat] = useState("");
  const [formArray, setFormArray] = useState("false");

  const [fieldTable, setFieldTable] = useState([]);

  const checkboxesRef = useRef([]);
  const isInitialLoad = useRef(true);
  //used for keys
  const handleKeyPress = useCallback((event) => {
    if (event.ctrlKey === true) {
      // shortcut handling
    }
  }, []);

  useEffect(() => {
    // attach the event listener
    document.addEventListener("keydown", handleKeyPress);

    // remove the event listener
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [handleKeyPress]);

  const handleCloseSnack = () => {
    setOpenSnack(false);
  };

  //Used for highlihting
  const [data, setData] = useState(null);
  const [areas, setAreas] = useState([]); // Use state for areas
  const changeArea = (pageIndex, width, height, x, y) => {
    setAreas([
      {
        pageIndex: pageIndex,
        height: height * 100,
        width: width * 100,
        left: x * 100,
        top: y * 100,
      },
    ]);
  };
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    sidebarTabs: (defaultTabs) => [
      // Remove the attachments tab (\`defaultTabs[2]\`)
    ],
  });
  const [content, setContent] = useState({
    json: "",
    text: undefined,
  });
  const [formValues, setformValues] = useState();

  useEffect(() => {
    const fetchData = async () => {
      const AWSData = await GetDocumentDetailInURL(documentID.id, "4");
      const getTemplateName = await GetDocumentDetailInURL(documentID.id, "5");
      const getModel = await GetDocumentDetailInURL(documentID.id, "6");
      const getReview = await GetDocumentDetailInURL(documentID.id, "7");
      const getPreviousOutput = await GetDocumentDetailInURL(
        documentID.id,
        "2"
      );
      // console.log("getReview", getReview);
      // console.log("AWSData", AWSData);
      try {
        setData(JSON.parse(AWSData));
      } catch (error) {
        console.error("Error parsing AWS data:", error);
        setData(null);
      }
      setTemplateName(getTemplateName);
      setModel(getModel);
      setReview(getReview);
      setPrevOutput(getPreviousOutput);
      // console.log("reviewstate==== ", review);
    };

    fetchData();
  }, [documentID.id]);
  const fetchFields = async () => {
    // Get the full document details to extract DocumentTypeTemplateId
    // We need to get the full response, not just OutputResult
    const currentApiURL = getBaseApiUrl(window.location.hostname);
    const url =
      currentApiURL + "/api/Document/GetDocumentDetailInURL/" + documentID.id;
    const headers = {
      Authorization: "Bearer " + sessionStorage.token,
    };

    // Step 1: Get the responseURL
    const response = await axiosApiInstance.get(url, { headers });
    const responseURL = response.data.responseURL;

    // Step 2: Get the full document data from the responseURL
    const fullDocumentResponse = await axiosApiInstance.get(responseURL);
    const fullDocumentData = fullDocumentResponse.data;

    const templateId = fullDocumentData.DocumentTypeTemplateId || 1;

    const URLData = await FieldsByTemplate(templateId);
    // console.log("FieldsByTemplate URLData:", URLData);
    // console.log("Setting summaryFieldDocuments with:", URLData);
    setSummaryFieldDocuments(URLData);
  };

  const fetchControllers = async () => {
    const ControllerData = await GetControllers();
    // console.log("ControllerData", ControllerData);
    setControllers(ControllerData);
  };
  useEffect(() => {
    if (model === "AWS Analyze Expense") {
      if (data && templateName === "Invoice") {
        var definedData = extractInvoiceDetails(
          extractTypeAndValueDetection(data.ExpenseDocuments[0].SummaryFields)
        );

        setDataForm(definedData);
        setInvoiceAmount(extractInvoiceAmount(content.json[0].SummaryFields));
      }
    }
  }, [data]);
  function extractTypeAndValueDetection(data) {
    return data.map((item) => ({
      Type: item.Type?.Text, // Retrieve the "Text" under "Type"
      ValueDetection: item.ValueDetection?.Text, // Retrieve the "Text" under "ValueDetection"
    }));
  }
  function extractInvoiceAmount(data) {
    let invoiceAmount = null;

    data.forEach((item) => {
      if (item.Name === "Invoice Amount") {
        invoiceAmount = item.Value;
      }
    });

    return invoiceAmount;
  }
  function generateTextFields(data) {
    return Object.entries(data).map(([key, value]) => (
      <TextField
        id="outlined-required"
        label={key}
        defaultValue={value}
        color="secondary"
        key={key}
        margin="dense"
        fullWidth
        size="medium"
      />
    ));
  }
  function extractInvoiceDetails(data) {
    const details = {
      "Invoice #": null,
      Date: null,
      Name: null,
      "Address: Street": null,
      City: null,
      State: null,
      "Zip Code": null,
    };

    data.forEach((item) => {
      switch (item.Type) {
        case "INVOICE_RECEIPT_ID":
          details["Invoice #"] = item.ValueDetection;
          break;
        case "INVOICE_RECEIPT_DATE":
          details["Date"] = item.ValueDetection;
          break;
        case "NAME":
          details["Name"] = item.ValueDetection;
          break;
        case "STREET":
          details["Address: Street"] = item.ValueDetection;
          break;
        case "CITY":
          details["City"] = item.ValueDetection;
          break;
        case "STATE":
          details["State"] = item.ValueDetection;
          break;
        case "ZIP_CODE":
          details["Zip Code"] = item.ValueDetection;
          break;
      }
    });

    return details;
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    if (dateFormat === "dd-MM-yyyy") {
      setDate(`${day}-${month}-${year}`);
      return `${day}-${month}-${year}`;
    } else if (dateFormat === "MM-dd-yyyy") {
      setDate(`${month}-${day}-${year}`);
      return `${month}-${day}-${year}`;
    } else {
      // Default format if no specific format is provided
      setDate(`${year}-${month}-${day}`);
      return `${year}-${month}-${day}`;
    }
  };

  useEffect(() => {
    if (
      summaryFieldDocuments !== undefined &&
      summaryFieldDocuments.length > 0 &&
      formValues !== undefined &&
      Array.isArray(controllers) &&
      controllers.length > 0
    ) {
      let mappedFields = [];
      let border = false;
      // console.log("summaryFieldDocuments", summaryFieldDocuments);
      if (Array.isArray(formValues)) {
        setFormArray("true");
        const result = formValues.map((value, indexOfFormvalues) => {
          summaryFieldDocuments.map((field, index) => {
            if (index === summaryFieldDocuments.length - 1) {
              border = true;
            } else {
              border = false;
            }

            const defaultValue = value[field.fieldName];
            const controller = "Textbox";

            mappedFields.push({
              ...field,
              controllerName: controller,
              defaultValue: defaultValue,
              border: border,
              index: indexOfFormvalues,
            });
          });
        });
      } else {
        mappedFields = summaryFieldDocuments.map((field) => {
          if (formValues !== null) {
            let defaultValue;
            let controller = controllers.find(
              (ctrl) => ctrl.id === field.controllerListID
            );

            defaultValue = formValues[field.fieldName.toLowerCase()]
              ? formValues[field.fieldName.toLowerCase()]
              : formValues[field.fieldName]
              ? formValues[field.fieldName]
              : "";

            if (
              controller &&
              controller.controllerName === "Date" &&
              controller.additionalValuesList
            ) {
              setdateFormat(controller.additionalValuesList || "yyyy-MM-dd");
              if (defaultValue && defaultValue !== "") {
                setDate(defaultValue);
                defaultValue = formatDate(defaultValue);
              }
            }

            if (
              controller &&
              controller.controllerName === "Dropdown" &&
              controller.additionalValuesList
            ) {
              const options = controller.additionalValuesList.split(",");
              defaultValue = options[0]; // Set the default value to the first option
            }
            if (
              controller &&
              controller.controllerName === "CheckBox List" &&
              defaultValue
            ) {
              defaultValue = checkboxgroup;
            }
            if (
              controller &&
              controller.controllerName === "CheckBox" &&
              defaultValue
            ) {
              setChecked(defaultValue);
            }
            if (
              controller &&
              controller.controllerName === "Textbox" &&
              field.dataTypeName === "Boolean"
            ) {
              if (!defaultValue) {
                defaultValue = "false";
              } else {
                defaultValue = "true";
              }
            }

            return {
              ...field,
              controllerName: controller
                ? controller.controllerName
                : "Textbox",
              defaultValue: defaultValue,
            };
          } else {
            return {
              ...field,
              controllerName: "Textbox",
              defaultValue: "",
            };
          }
        });
      }

      setFormData(mappedFields);
    }
  }, [formValues, summaryFieldDocuments, controllers]);

  // Force form refresh when data is ready
  useEffect(() => {
    if (
      summaryFieldDocuments.length > 0 &&
      formValues &&
      Object.keys(formValues).length > 0
    ) {
      // Trigger a re-render by updating a dummy state
      setFormData((prev) => [...prev]);
    }
  }, [summaryFieldDocuments.length, formValues]);

  useEffect(() => {
    const tableField = formData.find((f) => f.controllerName === "Table");
    if (tableField) {
      const headers = tableField.additionalValuesList?.split(",") || [];
      const defaultValue = tableField.defaultValue || [];
      setFieldTable(defaultValue);
    }
    const dateFormatting = formData.find((f) => f.controllerName === "Date");
    if (dateFormatting) {
      setdateFormat(dateFormatting.additionalValuesList || "yyyy-MM-dd"); // format from DB
    }
  }, [formData]);

  const renderField = (field) => {
    //console.log("field", field);
    let field_dropdown = {};
    let field_checkbox = {};
    let field_radio = {};
    let field_table = {};
    // console.log("field", field);
    if (field?.controllerName === "DropDown" && field?.additionalValuesList) {
      field_dropdown = {
        fieldName: field.fieldName,
        defaultValue: field.defaultValue,
        options: field.additionalValuesList.split(","),
      };
    }
    if (
      field?.controllerName === "CheckBox List" &&
      field?.additionalValuesList
    ) {
      field_checkbox = {
        fieldName: field.fieldName,
        defaultValue: field.defaultValue,
        options: field.additionalValuesList.split(","),
      };
    }
    if (
      field?.controllerName === "RadioButton List" &&
      field?.additionalValuesList
    ) {
      field_radio = {
        fieldName: field.fieldName,
        defaultValue: field.defaultValue,
        options: field.additionalValuesList.split(","),
      };
    }
    switch (field.controllerName) {
      case "Textbox":
        if (Array.isArray(field.defaultValue)) {
          // If it's an array, show it in a textarea as a formatted string
          return (
            <textarea
              className="dynamic_fields"
              name={field.fieldName}
              value={JSON.stringify(field.defaultValue, null, 2)} // or JSON.stringify(...) if you want full structure
              onChange={handleChange}
            />
          );
        } else if (typeof field.defaultValue === "object") {
          return (
            <textarea
              className="dynamic_fields"
              name={field.fieldName}
              value={JSON.stringify(field.defaultValue, null, 2)}
              onChange={handleChange}
            />
          );
        }
        return (
          <input
            className="dynamic_fields"
            type="text"
            name={field.fieldName}
            value={field.defaultValue || ""}
            onChange={(e) => handleChange(e, field.index)}
          />
        );

      case "TextArea":
        if (Array.isArray(field.defaultValue)) {
          return (
            <textarea
              className="dynamic_fields"
              name={field.fieldName}
              value={JSON.stringify(field.defaultValue, null, 2)}
              onChange={handleChange}
            />
          );
        } else if (typeof field.defaultValue === "object") {
          return (
            <textarea
              className="dynamic_fields"
              name={field.fieldName}
              value={JSON.stringify(field.defaultValue, null, 2)}
              onChange={handleChange}
            />
          );
        }
        return (
          <textarea
            className="dynamic_fields"
            name={field.fieldName}
            value={field.defaultValue || ""}
            onChange={handleChange}
          />
        );
      case "RadioButton List":
        return (
          <div className="radio_group">
            {field_radio.options?.map((option, idx) => (
              <label key={idx} className="radio_label">
                <input
                  className="dynamic_fields_radio"
                  type="radio"
                  name={field.fieldName}
                  value={option}
                  checked={field.defaultValue === option}
                  onChange={handleChange}
                />
                {option}
              </label>
            ))}
          </div>
        );

      case "Date":
        return (
          <input
            className="dynamic_fields"
            type="text"
            name={field.fieldName}
            value={field.defaultValue || ""}
            placeholder={
              field.additionalValuesList
                ? field.additionalValuesList
                : "mm-dd-yyyy"
            }
            onBlur={handleDateChange}
          />
        );
      case "Numeric":
        return (
          <input
            className="dynamic_fields"
            type="text"
            name={field.fieldName}
            value={field.defaultValue || ""}
            onChange={handleChange}
          />
        );
      case "CheckBox":
        return (
          <input
            className="dynamic_fields checkbox"
            type="checkbox"
            name={field.fieldName}
            checked={field.defaultValue}
            onChange={handleChange}
          />
        );
      case "CheckBox List":
        return (
          <div className="checkbox_group">
            {field_checkbox.options.map((option, index) => (
              <label key={index} className="checkbox_label">
                <input
                  className="dynamic_fields_checkbox"
                  type="checkbox"
                  id={index}
                  name={field.fieldName}
                  value={option}
                  defaultChecked={field.defaultValue.includes(option)}
                  // checked={field_checkbox.defaultValue.includes(option)}
                  ref={(el) => (checkboxesRef.current[index] = el)}
                  onChange={handlecheckboxChange}
                />
                {option}
              </label>
            ))}
          </div>
        );
      case "DropDown":
        return (
          <select
            className="dynamic_fields"
            name={field.fieldName}
            value={field.defaultValue || ""}
            onChange={handleChange}
          >
            {field_dropdown.options.map((option, index) => (
              <option
                key={index}
                value={option}
                selected={option === field.defaultValue}
              >
                {option}
              </option>
            ))}
          </select>
        );
      case "Table":
        const headers = field.additionalValuesList?.split(",") || [];
        return (
          <TableContainer className="dynamic_fields_table_container">
            <Table className="dynamic_fields_table" size="small">
              <TableHead>
                <TableRow>
                  {headers.map((header, index) => (
                    <TableCell
                      key={index}
                      sx={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {fieldTable.length > 0 ? (
                  fieldTable.map((row, rowIndex) => (
                    <TableRow key={rowIndex} hover>
                      {headers.map((header, cellIndex) => (
                        <TableCell key={cellIndex}>
                          <input
                            type="text"
                            value={row[header] || ""}
                            onChange={(e) =>
                              handleTableChange(
                                e,
                                rowIndex,
                                header,
                                field.fieldName
                              )
                            }
                            style={{
                              width: "100%",
                              border: "none",
                              background: "transparent",
                              padding: "4px 8px",
                              fontSize: "14px",
                            }}
                          />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={headers.length}
                      style={{ textAlign: "center" }}
                    >
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        );

      default:
        return (
          <input
            type="text"
            name={field.fieldName}
            value={field.defaultValue || ""}
            onChange={handleChange}
          />
        );
    }
  };

  useEffect(() => {
    // Reset initial load flag when documentID changes (new document)
    isInitialLoad.current = true;

    // Reset form-related state when document changes
    setFormData([]);
    setFieldTable([]);
    setformValues(null);
    setSummaryFieldDocuments([]);
    setDisplayUI("none");
    setLoading("flex");
  }, [documentID.id]);

  useEffect(() => {
    // Only fetch data on initial load, not after save operations
    if (!isInitialLoad.current) {
      return;
    }

    (async () => {
      try {
        // Fetch all document data in parallel
        const [getDocument, getImage] = await Promise.all([
          GetDocumentDetailInURL(documentID.id, "3"),
          GetImageDetail(documentID.id),
        ]);

        // Parse and set form values
        let parsedFormValues;
        try {
          parsedFormValues = JSON.parse(getDocument);
          setformValues(parsedFormValues);
          setContent({
            json: parsedFormValues,
            text: undefined,
          });
          setExtractedDocument(parsedFormValues);
        } catch (error) {
          console.error("Error parsing document data:", error);
          console.error("Raw document data:", getDocument);
          setformValues({});
          setContent({
            json: {},
            text: undefined,
          });
          setExtractedDocument({});
        }
        setDocumentImage(getImage);
        setDisableEditButton(true);

        // Fetch fields and controllers
        await fetchFields();
        fetchControllers();

        setDisplayUI("flex");
        setLoading("none");
      } catch (error) {
        console.error("Error loading document data:", error);
        setDisplayUI("flex");
        setLoading("none");
      }

      // Mark that initial load is complete
      isInitialLoad.current = false;
    })();
  }, [documentID]);

  useEffect(() => {
    const getdocuments = state.state?.documents || [];
    // console.log("getdocuments", getdocuments);
    if (getdocuments.length > 0) {
      const arrayDocuments = Array.from(getdocuments).filter(
        (item) => item.id == documentID.id
      );
      setCurrentIndex(
        getdocuments.findIndex(function (item) {
          return item.id == documentID.id;
        })
      );
      setDocumentDetails(arrayDocuments);
    }
  }, [documentID]);

  useEffect(() => {
    if (state.state?.documents?.length > 0) {
      setNextDocument((currentIndex + 1) % state.state.documents.length);
      setPrevDocument((currentIndex - 1) % state.state.documents.length);
    }
  }, [currentIndex]);

  const [errors, setErrors] = useState(false);

  const handleDateChange = (e) => {
    const newDate = e.target.value;

    let regex;
    if (dateFormat === "YYYY-MM-DD") {
      regex = /^\d{4}-\d{2}-\d{2}$/; // Example for YYYY-MM-DD
    } else if (dateFormat === "MM-dd-yyyy") {
      regex = /^\d{2}-\d{2}-\d{4}$/; // Example for MM-DD-YYYY
    } else {
      regex = /^\d{2}-\d{2}-\d{4}$/; // Example for DD-MM-YYYY
    }
    if (regex.test(newDate)) {
      setDate(newDate);
      const updatedFormData = [...formData];
      const index = updatedFormData.findIndex(
        (item) => item.fieldName === e.target.name
      );
      if (index !== -1) {
        updatedFormData[index].defaultValue = newDate;
      }
      setFormData(updatedFormData);
      setErrors(false);
    } else {
      setErrors(true);
      // return;
    }
    // return regex.test(dateString);

    // console.log(formatDate(newDate, 'dd-MM-yyyy'));
  };

  const handleChange = (e, formIndex = null) => {
    const { name, value, type, checked } = e.target;

    const updatedFormData = [...formData];
    const index = updatedFormData.findIndex(
      (item) => item.fieldName === name && item.index === formIndex
    );

    if (index !== -1) {
      // the index is found
      if (type == "checkbox") {
        updatedFormData[index].defaultValue = checked;
      } else {
        updatedFormData[index].defaultValue = value;
      }
    } else {
      const findIndex = updatedFormData.findIndex(
        (item) => item.fieldName === name
      );
      if (findIndex !== -1) {
        // the index is found
        if (type == "checkbox") {
          updatedFormData[findIndex].defaultValue = checked;
        } else {
          updatedFormData[findIndex].defaultValue = value;
        }
      }
    }

    setFormData(updatedFormData);
  };

  const handleTableChange = (e, rowIndex, header, fieldname) => {
    const updatedRows = [...fieldTable];
    updatedRows[rowIndex][header] = e.target.value;
    setFieldTable(updatedRows);

    const updatedFormData = [...formData];
    const index = updatedFormData.findIndex(
      (item) => item.fieldName === fieldname
    );
    if (index !== -1) {
      updatedFormData[index].defaultValue = updatedRows;
    }
    setFormData(updatedFormData);
  };

  const handlecheckboxChange = (e) => {
    const { name, value, checked } = e.target;
    let tempSelectedValues = [...selectedValues];
    if (checked) {
      tempSelectedValues = [...selectedValues, value];
    } else {
      tempSelectedValues = selectedValues.filter((item) => item !== value);
    }
    setSelectedValues(tempSelectedValues);

    const stringValues = tempSelectedValues.join(", ");
    //console.log(stringValues);
    const updatedFormData = [...formData];
    const index = updatedFormData.findIndex((item) => item.fieldName === name);
    if (index !== -1) {
      updatedFormData[index].defaultValue = stringValues;
    }
    setFormData(updatedFormData);
  };

  const handleApiCall = async (e) => {
    e.preventDefault(); // Prevent default form submission
    validateForm = 1;
    handleSubmit(e); // Pass the event parameter
  };

  const handleRestore = async (e) => {
    let validatedResult = {};
    try {
      validatedResult = prevOutput ? JSON.parse(prevOutput) : {};
    } catch (error) {
      console.error("Error parsing previous output:", error);
      console.error("Raw previous output:", prevOutput);
      validatedResult = {};
    }
    const updateDocument = await UpdateDocumentRestore(
      documentID.id,
      validatedResult,
      validateForm
    );
    if (updateDocument === 200) {
      setErrorMessage("Form data restored successfully");
      setOpenSnack(true);

      // Reload form data after successful restore
      try {
        const getDocument = await GetDocumentDetailInURL(documentID.id, "3");
        let parsedFormValues;
        try {
          parsedFormValues = JSON.parse(getDocument);
          setformValues(parsedFormValues);
          setContent({
            json: parsedFormValues,
            text: undefined,
          });
          setExtractedDocument(parsedFormValues);
        } catch (parseError) {
          console.error("Error parsing restored document data:", parseError);
          console.error("Raw restored document data:", getDocument);
          setformValues({});
          setContent({
            json: {},
            text: undefined,
          });
          setExtractedDocument({});
        }

        // Force form processing by triggering a re-render
        // The useEffect with [formValues, summaryFieldDocuments] should trigger
      } catch (error) {
        console.error("Error reloading form data after restore:", error);
      }
    } else {
      setErrorMessage("Could not update data.");
      setOpenSnack(true);
    }
  };

  const validate = () => {
    let newErrors = {};
    formData.forEach((field) => {});
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission behavior

    // Replace this with your save logic, e.g., API call

    const validationErrors = validate();
    let validatedResult;
    // console.log('errors===>', Object.keys(validationErrors).length);
    if (Object.keys(validationErrors).length === 0) {
      // Replace this with your save logic, e.g., API call
      if (!formArray) {
        validatedResult = [];
        formData.map((item) => {
          if (!validatedResult[item.index]) {
            validatedResult[item.index] = {};
          }
          validatedResult[item.index][item.fieldName] = item.defaultValue;
        });
      } else {
        validatedResult = formData.reduce((acc, obj) => {
          acc[obj.fieldName] = obj.defaultValue;
          return acc;
        }, {});
      }

      if (errors) {
        setErrorMessage(
          "Invalid date format. Please use the format " + dateFormat
        );
        setOpenSnack(true);
        return;
      } else {
        const updateDocument = await UpdateDocumentOutput(
          documentID.id,
          validatedResult,
          validateForm
        );
        if (updateDocument === 200) {
          if (validateForm === 1) {
            setErrorMessage("Form data validated successfully");
          } else {
            setErrorMessage("Form data saved successfully");
          }
          setOpenSnack(true);
        } else {
          setErrorMessage("Could not update data.");
          setOpenSnack(true);
        }
      }
    } else {
      // setErrors(validationErrors);
      setErrorMessage("Please fill all the fields");
    }
  };

  async function handleNext(event) {
    event.preventDefault();
    setDisplayUI("none");
    setLoading("flex");
    setDocumentImage(""); // Reset image to show loading
    navigate("/document/" + documents[nextDocument].id, {
      state: { documents },
    });
  }

  async function handlePrev(event) {
    event.preventDefault();
    setDisplayUI("none");
    setLoading("flex");
    setDocumentImage(""); // Reset image to show loading
    navigate("/document/" + documents[prevDocument].id, {
      state: { documents },
    });
  }

  if (documentImage.length < 1 || loading === "flex") {
    return (
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{ minHeight: "80vh" }}
        sx={{
          display: loading,
        }}
      >
        <CircularProgress color="secondary" />
      </Grid>
    );
  }
  return (
    <>
      <Grid
        container
        sx={{
          display: displayUI,
        }}
        style={{
          spacing: 0,
        }}
      >
        {documentDetails.map((document, index) => {
          return (
            <>
              <Grid
                container
                direction="row"
                style={{ width: "100%", textAlign: "center" }}
              >
                <Grid item sm="10">
                  <Breadcrumbs
                    separator={<NavigateNextIcon fontSize="large" />}
                    aria-label="breadcrumb"
                    sx={{ ml: { xs: 1, md: 5 }, mb: 0 }}
                  >
                    <Link
                      underline="hover"
                      key="1"
                      to="/completed"
                      style={{ textDecoration: "none" }}
                    >
                      Completed Documents
                    </Link>

                    <Box
                      sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <Typography key="3" color="text.primary">
                        {document.fileName}
                      </Typography>
                      <Box
                        sx={{ display: "inline-flex", alignItems: "center" }}
                      >
                        <i
                          class="xgl-issue xglsize-16"
                          style={{ marginRight: "4px", color: "#757575" }}
                        ></i>
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          sx={{ fontWeight: 500 }}
                        >
                          {document.stateFile}
                        </Typography>
                      </Box>
                    </Box>
                  </Breadcrumbs>
                </Grid>
                <Grid item sm="2">
                  <Box
                    display="flex"
                    justifyContent="flex-end"
                    alignItems="center"
                    mr={3}
                    gap={3}
                  >
                    <Box display="flex" alignItems="center" gap={2}>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ minWidth: "80px", textAlign: "center" }}
                      >
                        {currentIndex + 1} of {documents.length}
                      </Typography>
                      <Box display="flex" alignItems="center" gap={1}>
                        <Tooltip title="Previous Document">
                          <IconButton
                            onClick={handlePrev}
                            disabled={currentIndex <= 0}
                            color="secondary"
                            size="medium"
                            sx={{
                              border: "1px solid",
                              borderColor: "secondary.main",
                              "&:hover": {
                                backgroundColor: "secondary.main",
                                color: "white",
                              },
                              "&:disabled": {
                                borderColor: "grey.300",
                                color: "grey.400",
                              },
                            }}
                          >
                            <NavigateBeforeIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Next Document">
                          <IconButton
                            onClick={handleNext}
                            disabled={currentIndex >= documents.length - 1}
                            color="secondary"
                            size="medium"
                            sx={{
                              border: "1px solid",
                              borderColor: "secondary.main",
                              "&:hover": {
                                backgroundColor: "secondary.main",
                                color: "white",
                              },
                              "&:disabled": {
                                borderColor: "grey.300",
                                color: "grey.400",
                              },
                            }}
                          >
                            <NavigateNextIcon />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </Box>
                    <ExportBar
                      fileId={documentID}
                      fileName={document.fileName}
                    />
                  </Box>
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                alignItems="flex-start"
                justifyContent="flex-start"
                style={{ width: "100%", height: "calc(100vh - 200px)" }}
              >
                <Grid item xs>
                  {document.fileName.toLowerCase().includes("pdf") ? (
                    <div class="block-demo">
                      <RenderHighlightAreas
                        fileUrl={documentImage.url}
                        areas={areas}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {!document.fileName.toLowerCase().includes("pdf") &&
                  !document.fileName.toLowerCase().includes("tif") ? (
                    <Zoom>
                      <img
                        alt={document.fileName}
                        src={documentImage.url}
                        className="document-photo"
                      />
                    </Zoom>
                  ) : (
                    ""
                  )}
                </Grid>

                <Grid item xs>
                  {console.log(
                    "Form display check - model:",
                    model,
                    "templateName:",
                    templateName
                  )}
                  {model === "AWS Analyze Expense" ? (
                    // Show tabs only for AWS Analyze Expense
                    <Tabs>
                      {" "}
                      <TabList>
                        {templateName === "Invoice" ? (
                          <>
                            {" "}
                            <Tab>View Data</Tab>
                          </>
                        ) : (
                          <></>
                        )}
                        {data?.ExpenseDocuments?.length > 0 ? (
                          <>
                            <Tab>Summary Fields</Tab>
                            <Tab>Line Items</Tab>
                          </>
                        ) : (
                          ""
                        )}
                        {model && <Tab disabled={disableEditContent}>Edit</Tab>}
                      </TabList>
                      {templateName === "Invoice" ? (
                        <>
                          <TabPanel>
                            <div id="data">
                              <Grid
                                container
                                spacing={0}
                                direction="column"
                                alignItems="center"
                                justifyContent="center"
                              >
                                <Box sx={{ width: 500, maxWidth: "100%" }}>
                                  {generateTextFields(dataForm)}
                                  <TextField
                                    id="outlined-required"
                                    label="Invoice Amount"
                                    value={invoiceAmount}
                                    color="secondary"
                                    margin="dense"
                                    fullWidth
                                    size="medium"
                                  />
                                </Box>
                              </Grid>
                            </div>
                          </TabPanel>
                        </>
                      ) : (
                        <></>
                      )}
                      {data?.ExpenseDocuments?.length > 0 ? (
                        <TabPanel>
                          <div id="summaryfields">
                            {data?.ExpenseDocuments?.map((expenseDoc) => (
                              <>
                                <div key={expenseDoc.ExpenseIndex}>
                                  <div>
                                    {expenseDoc.SummaryFields?.map(
                                      (summaryField, summaryIndex) => (
                                        <div
                                          style={{
                                            cursor: "pointer",
                                            border:
                                              "1px solid rgb(170, 183, 184)",
                                            margin: "5px 0",
                                            backgroundColor: "white",
                                          }}
                                          key={summaryIndex}
                                          onClick={(event) =>
                                            changeArea(
                                              summaryField.PageNumber - 1,
                                              summaryField.ValueDetection
                                                .Geometry.BoundingBox.Width,
                                              summaryField.ValueDetection
                                                .Geometry.BoundingBox.Height,
                                              summaryField.ValueDetection
                                                .Geometry.BoundingBox.Left,
                                              summaryField.ValueDetection
                                                .Geometry.BoundingBox.Top
                                            )
                                          }
                                        >
                                          <strong>Type:</strong>{" "}
                                          {summaryField.Type.Text},
                                          <strong> Confidence:</strong>{" "}
                                          {
                                            summaryField.LabelDetection
                                              ?.Confidence
                                          }
                                          ,<strong>Value:</strong>{" "}
                                          {summaryField.ValueDetection?.Text ||
                                            "N/A"}
                                          ,<strong>Label Detection:</strong>{" "}
                                          {summaryField.LabelDetection?.Text ||
                                            "N/A"}
                                          <br />
                                        </div>
                                      )
                                    )}
                                  </div>
                                </div>
                              </>
                            ))}
                          </div>
                        </TabPanel>
                      ) : (
                        ""
                      )}
                      {data?.ExpenseDocuments?.length > 0 ? (
                        <TabPanel>
                          <div id="lineItems">
                            {data?.ExpenseDocuments?.map((expenseDoc) => (
                              <div key={expenseDoc.ExpenseIndex}>
                                <div>
                                  {expenseDoc.LineItemGroups?.map(
                                    (lnItems, lineItemGroupIndex) =>
                                      lnItems.LineItems?.map(
                                        (lineItem, lineItemIndex) => (
                                          <div
                                            style={{
                                              border:
                                                "1px solid rgb(170, 183, 184)",
                                              margin: "5px 0",
                                              backgroundColor: "white",
                                            }}
                                            key={"row " + (lineItemIndex + 1)}
                                          >
                                            <h4>Line {lineItemIndex + 1}</h4>

                                            {lineItem.LineItemExpenseFields?.map(
                                              (
                                                lineItemExpenseField,
                                                lineItemExpenseFieldIndex
                                              ) => (
                                                <div
                                                  style={{
                                                    cursor: "pointer",
                                                    border:
                                                      "1px solid rgb(170, 183, 184)",
                                                    margin: "5px 0",
                                                  }}
                                                  onClick={(event) =>
                                                    changeArea(
                                                      lineItemExpenseField.PageNumber -
                                                        1,
                                                      lineItemExpenseField
                                                        .ValueDetection.Geometry
                                                        .BoundingBox.Width,
                                                      lineItemExpenseField
                                                        .ValueDetection.Geometry
                                                        .BoundingBox.Height,
                                                      lineItemExpenseField
                                                        .ValueDetection.Geometry
                                                        .BoundingBox.Left,
                                                      lineItemExpenseField
                                                        .ValueDetection.Geometry
                                                        .BoundingBox.Top
                                                    )
                                                  }
                                                >
                                                  <div
                                                    key={
                                                      lineItemExpenseFieldIndex
                                                    }
                                                  >
                                                    <strong>Value:</strong>
                                                    {
                                                      lineItemExpenseField
                                                        .ValueDetection?.Text
                                                    }
                                                  </div>

                                                  <div>
                                                    {" "}
                                                    <strong>Type:</strong>{" "}
                                                    {
                                                      lineItemExpenseField.Type
                                                        .Text
                                                    }
                                                  </div>
                                                  <div>
                                                    <strong>
                                                      {" "}
                                                      Confidence:
                                                    </strong>{" "}
                                                    {
                                                      lineItemExpenseField
                                                        .ValueDetection
                                                        ?.Confidence
                                                    }
                                                  </div>
                                                </div>
                                              )
                                            )}
                                          </div>
                                        )
                                      )
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        </TabPanel>
                      ) : (
                        ""
                      )}
                      <TabPanel>
                        <div
                          id="editItems"
                          sx={{
                            display: disableEditContent,
                          }}
                        >
                          <JsonView data={content} />
                        </div>
                      </TabPanel>
                    </Tabs>
                  ) : (
                    // Show form directly (no tabs) for all other document types
                    <div>
                      {console.log(
                        "Form section - model:",
                        model,
                        "formData length:",
                        formData.length
                      )}
                      {model === "" ? (
                        ""
                      ) : (
                        <form
                          className="dynamic_form"
                          onSubmit={handleSubmit}
                          key={`form-${formData.length}-${summaryFieldDocuments.length}`}
                        >
                          {formData.map((field, index) => (
                            <>
                              <div
                                className="dynamic_div"
                                key={`${field.fieldName}-${index}`}
                              >
                                {field.controllerName !== "Table" && (
                                  <label className="dynamic_label">
                                    {field.fieldName}
                                  </label>
                                )}
                                {renderField(field)}

                                {errors[field.fieldName] && (
                                  <span className="form_error">
                                    {errors[field.fieldName]}
                                  </span>
                                )}
                              </div>
                              {field.border && <hr className="borderLine" />}
                            </>
                          ))}

                          <div
                            style={{
                              display: "flex",
                              gap: "12px",
                              marginTop: "32px",
                              width: "100%",
                            }}
                          >
                            <button
                              type="button"
                              className="xrx-btn btn-default"
                              onClick={handleRestore}
                              disabled={review}
                            >
                              <span className="btn-label">Restore</span>
                            </button>
                            <button
                              type="submit"
                              className="xrx-btn btn-success"
                              disabled={review}
                            >
                              <span className="btn-label">Save</span>
                            </button>
                            <button
                              type="button"
                              className="xrx-btn btn-primary"
                              onClick={handleApiCall}
                              disabled={review}
                            >
                              <span className="btn-label">Validate</span>
                            </button>
                          </div>
                        </form>
                      )}
                    </div>
                  )}
                </Grid>
              </Grid>
            </>
          );
        })}
      </Grid>

      <Grid>
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={openSnack}
          onClose={handleCloseSnack}
          message={errorMessage}
          autoHideDuration={3000}
        />
      </Grid>
    </>
  );
}

export default Document;

/*

      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={1} style={{ textAlign: "center" }}>
          <Tooltip title="Previous Document">
            <Link underline="hover" onClick={handleNext}>
              Prev
            </Link>
          </Tooltip>
        </Grid>

        <Grid item xs={1} style={{ textAlign: "center" }}>
          <Tooltip title="Next Document">
            <Link underline="hover" onClick={handlePrev}>
              Next
            </Link>
          </Tooltip>
        </Grid>
      </Grid>

                 <Grid
                    container
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <Grid item>
                      <Box>
                        <div class="my-json-editor">
                          <SvelteJSONEditor
                            content={content}
                            readOnly={readOnly}
                            onChange={setContent}
                          />
                        </div>
                      </Box>
                    </Grid>
                  </Grid>
                  */
